import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Route } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import * as authService from '~/services/authentication';

const useStyles = makeStyles()({
  background: {
    marginTop: '30px',
    width: '100%',
    padding: '10px',
    alignContent: 'center',
    justifyContent: 'center',
  },

  control: {
    margin: '10px 0',
  },

  form: {
    width: '100%',
    padding: '1.5rem',
  },

  buttonContainer: {
    textAlign: 'end',
  },
  resetLink: {
    marginLeft: '24px',
    marginBottom: '16px',
    textDecoration: 'none',
  },
});

type PasswordResetProps = {
  classes: ReturnType<typeof useStyles>['classes'];
};
interface PasswordResetState {
  formFeedback: string;
  username: string;
  formError: boolean;
}
class PasswordReset extends React.Component<PasswordResetProps, PasswordResetState> {
  constructor(props: PasswordResetProps) {
    super(props);
    this.state = {
      formFeedback: '',
      username: '',
      formError: false,
    };
  }

  handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ username: e.target.value });
  };

  handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { username } = this.state;
    this.setState({ formFeedback: '', formError: false });

    try {
      await authService.resetPass(username);
      this.setState({
        username: '',
        formFeedback: 'Ett mail med instruktioner för återställning av lösenord har skickats till ' + username,
        formError: false,
      });
    } catch (error: any) {
      this.setState({ formFeedback: error.message, formError: true });
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Grid container item xl={3} lg={3} md={6} xs={12}>
        <Paper className={classes.background}>
          <form className={classes.form} autoComplete="on" onSubmit={this.handleSubmit}>
            <Typography variant="h5">Återställ lösenord</Typography>
            <Grid container item xs={12} justifyContent="center">
              <Grid item xs={12}>
                <TextField
                  variant="standard"
                  className={classes.control}
                  fullWidth={true}
                  label="Användarnamn"
                  name="username"
                  id="username"
                  value={this.state.username}
                  onChange={this.handleUsernameChange}
                />
              </Grid>
              <Grid item container xs={12} alignItems="center">
                <Grid item xs={6}>
                  <Route
                    render={({ history }) => (
                      <Button color="primary" variant="contained" onClick={() => history.push('/login')}>
                        Tillbaka
                      </Button>
                    )}
                  />
                </Grid>
                <Grid container item xs={6} className={classes.buttonContainer} justifyContent="flex-end">
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    value="LOGIN"
                    disabled={!this.state.username.trim()}
                  >
                    Återställ lösenord
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Typography color={this.state.formError ? 'error' : 'primary'}>{this.state.formFeedback}</Typography>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Grid>
    );
  }
}

const Wrapper = (props: Omit<PasswordResetProps, 'classes'>) => {
  const { classes } = useStyles();

  return <PasswordReset classes={classes} {...props} />;
};

export default Wrapper;
